import { PageHeader } from '@shared/components';

import { ExamLocationManagementNavigationTabs } from '../exam-location-management-navigation-tabs';

export default function ExamLocationManagementHeader() {
  return <PageHeader title='จัดการสถานที่สอบ' tabs={<ExamLocationManagementNavigationTabs />} />;
}
